import { LocaleDict } from "@/i18n";
import { ComputeFieldComponent } from "../../computeFields";

export const InscriptionDosCF: ComputeFieldComponent<{
  inscription?: LocaleDict<string> | null;
  published?: LocaleDict<boolean> | null;
}> = ({ input, lineBreak = false, inline = false, language }) => {
  if (!input.inscription || !input.published) {
    return null;
  }

  let inscription = input.inscription[language] ?? "";
  const published = input.published[language] ?? false;

  if (!published) {
    return null;
  }

  if (inline) {
    inscription = `${inscription.charAt(0).toLowerCase()}${inscription.slice(1)}`;
  }

  return (
    <>
      {inscription}
      {inscription && lineBreak && <br />}
    </>
  );
};
